(function ($) {
	$.fn.resourceModal = function () {
		return this.each((i, el) => {
			const $self = $(el);
            const $modalBody = $self.find('.modal-body');
            const $spinner = $self.find('.spinner-container');
            const ajaxConfig = JSON.parse(($self.attr('ajax-config') ? $self.attr('ajax-config') : '{}'));
            
            $self.on('fr-load-resource-details', (e, resourceId, previewNonce = false) => {
                if(resourceId){
                    reset();
                    loadResource(resourceId, previewNonce);
                    $self.modal('show');
                }
            });

            const loadResource = (resourceId, previewNonce = false) => {
                ajaxConfig.resource_id = resourceId;

                if(previewNonce){
                    ajaxConfig.preview_nonce = previewNonce;
                }
                
                $.frAjax({
                    url: ajaxConfig.url,
                    action: ajaxConfig.action,
                    data: ajaxConfig,
                }).then(resData => {
                    $modalBody.append(resData.resource);
                    $self.find('.resource-hero, .resource-content').addClass('modal-view');
                    $self.find('.resource-hero').heroShapeResize();
                    $spinner.hide();
                }).catch(err => {
                    $self.modal('hide');
                    console.log(`Error ${err}`);
                });
            }

            const reset = () => {
                $self.find('.resource-details').remove();
                $spinner.show();
            }
		});
	}

	$(() => {
		$('#fr-modal-resource-details').resourceModal();
	});
})($);